export type CaptureActivityMessage =
	| { type: 'capture-active'; tabId: string }
	| { type: 'capture-inactive'; tabId: string }
	| { type: 'capture-activity-probe' };

const CHANNEL_NAME = 'dixit-capture-activity';

type ChannelFactory = (name: string) => BroadcastChannel | undefined;

const createBrowserChannel: ChannelFactory = (name) => {
	return typeof BroadcastChannel === 'undefined' ? undefined : new BroadcastChannel(name);
};

/**
 * Same-origin message bus between tabs. Constructing it does nothing: the underlying
 * `BroadcastChannel` only exists between `open` and `close`, and every method is a no-op when the
 * platform lacks `BroadcastChannel`.
 */
class BroadcastCaptureActivityChannel {
	private channel: BroadcastChannel | undefined;

	constructor(private readonly createChannel: ChannelFactory = createBrowserChannel) {}

	open(onMessage: (data: unknown) => void): void {
		if (this.channel) {
			return;
		}

		const channel = this.createChannel(CHANNEL_NAME);

		if (!channel) {
			return;
		}

		channel.onmessage = (event: MessageEvent<unknown>) => onMessage(event.data);
		this.channel = channel;
	}

	post(message: CaptureActivityMessage): void {
		this.channel?.postMessage(message);
	}

	close(): void {
		if (!this.channel) {
			return;
		}

		this.channel.onmessage = null;
		this.channel.close();
		this.channel = undefined;
	}
}

export default BroadcastCaptureActivityChannel;
